// Generated by KlangScriptProcessor, DO NOT EDIT
@file:Suppress("UNCHECKED_CAST", "UNUSED_PARAMETER", "UnusedImport")

package io.peekandpoke.klang.script.generated

import io.peekandpoke.klang.script.KlangScriptLibrary
import io.peekandpoke.klang.script.annotations.KlangScope
import io.peekandpoke.klang.script.ast.CallInfo
import io.peekandpoke.klang.script.builder.*
import io.peekandpoke.klang.script.runtime.*
import io.peekandpoke.klang.script.types.*

import io.peekandpoke.klang.audio_bridge.AdsrBuilder
import io.peekandpoke.klang.audio_bridge.BandFilterBuilder
import io.peekandpoke.klang.audio_bridge.EqBuilder
import io.peekandpoke.klang.audio_bridge.FilterBuilder
import io.peekandpoke.klang.audio_bridge.FmBuilder
import io.peekandpoke.klang.audio_bridge.IgnitorBandsBuilder
import io.peekandpoke.klang.audio_bridge.IgnitorDsl
import io.peekandpoke.klang.audio_bridge.KatalystBandsBuilder
import io.peekandpoke.klang.audio_bridge.KatalystBodyBuilder
import io.peekandpoke.klang.audio_bridge.KatalystBuilder
import io.peekandpoke.klang.audio_bridge.KatalystDelayBuilder
import io.peekandpoke.klang.audio_bridge.KatalystDsl
import io.peekandpoke.klang.audio_bridge.KatalystEqBuilder
import io.peekandpoke.klang.audio_bridge.KatalystKnobDsl
import io.peekandpoke.klang.audio_bridge.KatalystPhaserBuilder
import io.peekandpoke.klang.audio_bridge.KatalystRampBuilder
import io.peekandpoke.klang.audio_bridge.KatalystSawBuilder
import io.peekandpoke.klang.audio_bridge.KatalystSineBuilder
import io.peekandpoke.klang.audio_bridge.KatalystSquareBuilder
import io.peekandpoke.klang.audio_bridge.KatalystTriBuilder
import io.peekandpoke.klang.audio_bridge.KatalystVowelBuilder
import io.peekandpoke.klang.audio_bridge.ModAdsrBuilder
import io.peekandpoke.klang.audio_bridge.OscImpulseBuilder
import io.peekandpoke.klang.audio_bridge.OscPluckBuilder
import io.peekandpoke.klang.audio_bridge.OscPulzeBuilder
import io.peekandpoke.klang.audio_bridge.OscRampBuilder
import io.peekandpoke.klang.audio_bridge.OscSawBuilder
import io.peekandpoke.klang.audio_bridge.OscSineBuilder
import io.peekandpoke.klang.audio_bridge.OscSquareBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperPluckBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperRampBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperSawBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperSineBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperSquareBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperTriBuilder
import io.peekandpoke.klang.audio_bridge.OscTriBuilder
import io.peekandpoke.klang.audio_bridge.OscZampBuilder
import io.peekandpoke.klang.audio_bridge.OscZawtoothBuilder
import io.peekandpoke.klang.audio_bridge.PhaserBuilder
import io.peekandpoke.klang.audio_bridge.PitchEnvelopeBuilder
import io.peekandpoke.klang.audio_bridge.ShimmerBuilder
import io.peekandpoke.klang.audio_bridge.TremoloBuilder
import io.peekandpoke.klang.audio_bridge.VibratoBuilder
import io.peekandpoke.klang.common.SourceLocation
import io.peekandpoke.klang.script.runtime.ArrayValue
import io.peekandpoke.klang.script.runtime.BooleanValue
import io.peekandpoke.klang.script.runtime.NumberValue
import io.peekandpoke.klang.script.runtime.RuntimeValue
import io.peekandpoke.klang.script.runtime.StringValue
import io.peekandpoke.klang.script.stdlib.E
import io.peekandpoke.klang.script.stdlib.Ign
import io.peekandpoke.klang.script.stdlib.IgnitorDslLike
import io.peekandpoke.klang.script.stdlib.Kat
import io.peekandpoke.klang.script.stdlib.KlangScriptArrayExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptBooleanExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitor
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorAdsrCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorAdsrSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorBpfCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorBpfSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorCoarseSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorCrushSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorDistortSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorFmSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorHpfCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorHpfSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorLpfCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorLpfSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorNotchCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorNotchSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorPenvCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorPenvSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorTremoloSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorVibratoSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalyst
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystBodySlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystCompressorSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystDelaySlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystDuckSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystGainSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystPhaserSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystReverbSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystVowelSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptMath
import io.peekandpoke.klang.script.stdlib.KlangScriptNumberExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptObjectUtility
import io.peekandpoke.klang.script.stdlib.KlangScriptStringExtensions
import io.peekandpoke.klang.script.stdlib.PI
import io.peekandpoke.klang.script.stdlib.scriptAbs
import io.peekandpoke.klang.script.stdlib.scriptAdd
import io.peekandpoke.klang.script.stdlib.scriptAdsr
import io.peekandpoke.klang.script.stdlib.scriptAnalog
import io.peekandpoke.klang.script.stdlib.scriptAnalogSpread
import io.peekandpoke.klang.script.stdlib.scriptBand
import io.peekandpoke.klang.script.stdlib.scriptBands
import io.peekandpoke.klang.script.stdlib.scriptBlend
import io.peekandpoke.klang.script.stdlib.scriptBody
import io.peekandpoke.klang.script.stdlib.scriptBrightness
import io.peekandpoke.klang.script.stdlib.scriptCap
import io.peekandpoke.klang.script.stdlib.scriptCenterJitter
import io.peekandpoke.klang.script.stdlib.scriptClassic
import io.peekandpoke.klang.script.stdlib.scriptCompressor
import io.peekandpoke.klang.script.stdlib.scriptCurves
import io.peekandpoke.klang.script.stdlib.scriptCut
import io.peekandpoke.klang.script.stdlib.scriptDeclick
import io.peekandpoke.klang.script.stdlib.scriptDelay
import io.peekandpoke.klang.script.stdlib.scriptDistort
import io.peekandpoke.klang.script.stdlib.scriptDiv
import io.peekandpoke.klang.script.stdlib.scriptDuck
import io.peekandpoke.klang.script.stdlib.scriptDuty
import io.peekandpoke.klang.script.stdlib.scriptEnv
import io.peekandpoke.klang.script.stdlib.scriptEq
import io.peekandpoke.klang.script.stdlib.scriptFallFlank
import io.peekandpoke.klang.script.stdlib.scriptFeedback
import io.peekandpoke.klang.script.stdlib.scriptFlankSamples
import io.peekandpoke.klang.script.stdlib.scriptFloor
import io.peekandpoke.klang.script.stdlib.scriptFundamental
import io.peekandpoke.klang.script.stdlib.scriptGain
import io.peekandpoke.klang.script.stdlib.scriptGainJitter
import io.peekandpoke.klang.script.stdlib.scriptHarmonics
import io.peekandpoke.klang.script.stdlib.scriptHumanize
import io.peekandpoke.klang.script.stdlib.scriptLimiter
import io.peekandpoke.klang.script.stdlib.scriptMax
import io.peekandpoke.klang.script.stdlib.scriptMin
import io.peekandpoke.klang.script.stdlib.scriptMinus
import io.peekandpoke.klang.script.stdlib.scriptMul
import io.peekandpoke.klang.script.stdlib.scriptNeg
import io.peekandpoke.klang.script.stdlib.scriptNegate
import io.peekandpoke.klang.script.stdlib.scriptOctaves
import io.peekandpoke.klang.script.stdlib.scriptOversampleAtLeast
import io.peekandpoke.klang.script.stdlib.scriptOversampleBy
import io.peekandpoke.klang.script.stdlib.scriptParallel
import io.peekandpoke.klang.script.stdlib.scriptPartial
import io.peekandpoke.klang.script.stdlib.scriptPasses
import io.peekandpoke.klang.script.stdlib.scriptPhase
import io.peekandpoke.klang.script.stdlib.scriptPhasePool
import io.peekandpoke.klang.script.stdlib.scriptPhaser
import io.peekandpoke.klang.script.stdlib.scriptPickPosition
import io.peekandpoke.klang.script.stdlib.scriptPlus
import io.peekandpoke.klang.script.stdlib.scriptPow
import io.peekandpoke.klang.script.stdlib.scriptPower
import io.peekandpoke.klang.script.stdlib.scriptRange
import io.peekandpoke.klang.script.stdlib.scriptResetSamples
import io.peekandpoke.klang.script.stdlib.scriptReverb
import io.peekandpoke.klang.script.stdlib.scriptRiseFlank
import io.peekandpoke.klang.script.stdlib.scriptSerial
import io.peekandpoke.klang.script.stdlib.scriptShape
import io.peekandpoke.klang.script.stdlib.scriptShapeMax
import io.peekandpoke.klang.script.stdlib.scriptSideAtten
import io.peekandpoke.klang.script.stdlib.scriptSpread
import io.peekandpoke.klang.script.stdlib.scriptSpreadPower
import io.peekandpoke.klang.script.stdlib.scriptStiffness
import io.peekandpoke.klang.script.stdlib.scriptSub
import io.peekandpoke.klang.script.stdlib.scriptSuboctaves
import io.peekandpoke.klang.script.stdlib.scriptTap
import io.peekandpoke.klang.script.stdlib.scriptTimes
import io.peekandpoke.klang.script.stdlib.scriptVoices
import io.peekandpoke.klang.script.stdlib.scriptVowel

internal fun KlangScriptExtensionBuilder.registerStdlibIgnitorBuildersChunk0() {

    // @TypeExtensions(OscSineBuilder::class) on OscSineBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSineBuilder::class,
        name = "phase",
        paramSpecs = listOf(
            ParamSpec(name = "phase", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSineBuilder::class, loc)
        checkArgsSize(fn = "phase", args = args, expected = 1, location = loc)
        val phase = convertArgToKotlin(fn = "phase", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPhase(phase = phase))
    }

    // @TypeExtensions(OscSineBuilder::class) on OscSineBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSineBuilder::class,
        name = "analog",
        paramSpecs = listOf(
            ParamSpec(name = "character", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSineBuilder::class, loc)
        checkArgsSize(fn = "analog", args = args, expected = 1, location = loc)
        val character = convertArgToKotlin(fn = "analog", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalog(character = character))
    }

    // @TypeExtensions(OscSineBuilder::class) on OscSineBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSineBuilder::class,
        name = "fundamental",
        paramSpecs = listOf(
            ParamSpec(name = "gain", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSineBuilder::class, loc)
        checkArgsSize(fn = "fundamental", args = args, expected = 1, location = loc)
        val gain = convertArgToKotlin(fn = "fundamental", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptFundamental(gain = gain))
    }

    // @TypeExtensions(OscSineBuilder::class) on OscSineBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSineBuilder::class,
        name = "harmonics",
        paramSpecs = listOf(
            ParamSpec(name = "count", kotlinType = Any::class),
            ParamSpec(name = "rolloff", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSineBuilder::class, loc)
        checkArgsSize(fn = "harmonics", args = args, expected = 1, location = loc)
        val count = convertArgToKotlin(fn = "harmonics", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(
            typedReceiver.scriptHarmonics(
                count = count,
                rolloff = if (args.size > 1) convertArgToKotlin(fn = "harmonics", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 1.0,
            )
        )
    }

    // @TypeExtensions(OscSineBuilder::class) on OscSineBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSineBuilder::class,
        name = "octaves",
        paramSpecs = listOf(
            ParamSpec(name = "count", kotlinType = Any::class),
            ParamSpec(name = "rolloff", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSineBuilder::class, loc)
        checkArgsSize(fn = "octaves", args = args, expected = 1, location = loc)
        val count = convertArgToKotlin(fn = "octaves", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(
            typedReceiver.scriptOctaves(
                count = count,
                rolloff = if (args.size > 1) convertArgToKotlin(fn = "octaves", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 1.0,
            )
        )
    }

    // @TypeExtensions(OscSineBuilder::class) on OscSineBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSineBuilder::class,
        name = "suboctaves",
        paramSpecs = listOf(
            ParamSpec(name = "count", kotlinType = Any::class),
            ParamSpec(name = "rolloff", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSineBuilder::class, loc)
        checkArgsSize(fn = "suboctaves", args = args, expected = 1, location = loc)
        val count = convertArgToKotlin(fn = "suboctaves", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(
            typedReceiver.scriptSuboctaves(
                count = count,
                rolloff = if (args.size > 1) convertArgToKotlin(fn = "suboctaves", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 1.0,
            )
        )
    }

    // @TypeExtensions(OscSineBuilder::class) on OscSineBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSineBuilder::class,
        name = "partial",
        paramSpecs = listOf(
            ParamSpec(name = "ratio", kotlinType = Any::class),
            ParamSpec(name = "gain", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) }),
            ParamSpec(name = "phase", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSineBuilder::class, loc)
        checkArgsSize(fn = "partial", args = args, expected = 1, location = loc)
        val ratio = convertArgToKotlin(fn = "partial", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(
            typedReceiver.scriptPartial(
                ratio = ratio,
                gain = if (args.size > 1) convertArgToKotlin(fn = "partial", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 1.0,
                phase = if (args.size > 2) convertArgToKotlin(fn = "partial", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any else 0.0,
            )
        )
    }

    // @TypeExtensions(OscSineBuilder::class) on OscSineBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSineBuilder::class,
        name = "analogSpread",
        paramSpecs = listOf(
            ParamSpec(name = "amount", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSineBuilder::class, loc)
        checkArgsSize(fn = "analogSpread", args = args, expected = 1, location = loc)
        val amount = convertArgToKotlin(fn = "analogSpread", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalogSpread(amount = amount))
    }

    // @TypeExtensions(OscTriBuilder::class) on OscTriBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscTriBuilder::class,
        name = "phase",
        paramSpecs = listOf(
            ParamSpec(name = "phase", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscTriBuilder::class, loc)
        checkArgsSize(fn = "phase", args = args, expected = 1, location = loc)
        val phase = convertArgToKotlin(fn = "phase", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPhase(phase = phase))
    }

    // @TypeExtensions(OscTriBuilder::class) on OscTriBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscTriBuilder::class,
        name = "analog",
        paramSpecs = listOf(
            ParamSpec(name = "character", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscTriBuilder::class, loc)
        checkArgsSize(fn = "analog", args = args, expected = 1, location = loc)
        val character = convertArgToKotlin(fn = "analog", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalog(character = character))
    }

    // @TypeExtensions(OscZawtoothBuilder::class) on OscZawtoothBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscZawtoothBuilder::class,
        name = "phase",
        paramSpecs = listOf(
            ParamSpec(name = "phase", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscZawtoothBuilder::class, loc)
        checkArgsSize(fn = "phase", args = args, expected = 1, location = loc)
        val phase = convertArgToKotlin(fn = "phase", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPhase(phase = phase))
    }

    // @TypeExtensions(OscZawtoothBuilder::class) on OscZawtoothBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscZawtoothBuilder::class,
        name = "analog",
        paramSpecs = listOf(
            ParamSpec(name = "character", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscZawtoothBuilder::class, loc)
        checkArgsSize(fn = "analog", args = args, expected = 1, location = loc)
        val character = convertArgToKotlin(fn = "analog", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalog(character = character))
    }

    // @TypeExtensions(OscZampBuilder::class) on OscZampBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscZampBuilder::class,
        name = "phase",
        paramSpecs = listOf(
            ParamSpec(name = "phase", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscZampBuilder::class, loc)
        checkArgsSize(fn = "phase", args = args, expected = 1, location = loc)
        val phase = convertArgToKotlin(fn = "phase", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPhase(phase = phase))
    }

    // @TypeExtensions(OscZampBuilder::class) on OscZampBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscZampBuilder::class,
        name = "analog",
        paramSpecs = listOf(
            ParamSpec(name = "character", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscZampBuilder::class, loc)
        checkArgsSize(fn = "analog", args = args, expected = 1, location = loc)
        val character = convertArgToKotlin(fn = "analog", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalog(character = character))
    }

    // @TypeExtensions(OscImpulseBuilder::class) on OscImpulseBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscImpulseBuilder::class,
        name = "phase",
        paramSpecs = listOf(
            ParamSpec(name = "phase", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscImpulseBuilder::class, loc)
        checkArgsSize(fn = "phase", args = args, expected = 1, location = loc)
        val phase = convertArgToKotlin(fn = "phase", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPhase(phase = phase))
    }

    // @TypeExtensions(OscImpulseBuilder::class) on OscImpulseBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscImpulseBuilder::class,
        name = "analog",
        paramSpecs = listOf(
            ParamSpec(name = "character", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscImpulseBuilder::class, loc)
        checkArgsSize(fn = "analog", args = args, expected = 1, location = loc)
        val character = convertArgToKotlin(fn = "analog", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalog(character = character))
    }

    // @TypeExtensions(OscPulzeBuilder::class) on OscPulzeBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscPulzeBuilder::class,
        name = "phase",
        paramSpecs = listOf(
            ParamSpec(name = "phase", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscPulzeBuilder::class, loc)
        checkArgsSize(fn = "phase", args = args, expected = 1, location = loc)
        val phase = convertArgToKotlin(fn = "phase", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPhase(phase = phase))
    }

    // @TypeExtensions(OscPulzeBuilder::class) on OscPulzeBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscPulzeBuilder::class,
        name = "duty",
        paramSpecs = listOf(
            ParamSpec(name = "width", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscPulzeBuilder::class, loc)
        checkArgsSize(fn = "duty", args = args, expected = 1, location = loc)
        val width = convertArgToKotlin(fn = "duty", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptDuty(width = width))
    }

    // @TypeExtensions(OscPulzeBuilder::class) on OscPulzeBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscPulzeBuilder::class,
        name = "analog",
        paramSpecs = listOf(
            ParamSpec(name = "character", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscPulzeBuilder::class, loc)
        checkArgsSize(fn = "analog", args = args, expected = 1, location = loc)
        val character = convertArgToKotlin(fn = "analog", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalog(character = character))
    }

    // @TypeExtensions(OscSquareBuilder::class) on OscSquareBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSquareBuilder::class,
        name = "phase",
        paramSpecs = listOf(
            ParamSpec(name = "phase", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSquareBuilder::class, loc)
        checkArgsSize(fn = "phase", args = args, expected = 1, location = loc)
        val phase = convertArgToKotlin(fn = "phase", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPhase(phase = phase))
    }

    // @TypeExtensions(OscSquareBuilder::class) on OscSquareBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSquareBuilder::class,
        name = "duty",
        paramSpecs = listOf(
            ParamSpec(name = "width", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSquareBuilder::class, loc)
        checkArgsSize(fn = "duty", args = args, expected = 1, location = loc)
        val width = convertArgToKotlin(fn = "duty", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptDuty(width = width))
    }

    // @TypeExtensions(OscSquareBuilder::class) on OscSquareBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSquareBuilder::class,
        name = "analog",
        paramSpecs = listOf(
            ParamSpec(name = "character", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSquareBuilder::class, loc)
        checkArgsSize(fn = "analog", args = args, expected = 1, location = loc)
        val character = convertArgToKotlin(fn = "analog", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalog(character = character))
    }

    // @TypeExtensions(OscSquareBuilder::class) on OscSquareBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSquareBuilder::class,
        name = "flankSamples",
        paramSpecs = listOf(
            ParamSpec(name = "flankSamples", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSquareBuilder::class, loc)
        checkArgsSize(fn = "flankSamples", args = args, expected = 1, location = loc)
        val flankSamples = convertArgToKotlin(fn = "flankSamples", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptFlankSamples(flankSamples = flankSamples))
    }

    // @TypeExtensions(OscSquareBuilder::class) on OscSquareBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSquareBuilder::class,
        name = "riseFlank",
        paramSpecs = listOf(
            ParamSpec(name = "riseFlank", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSquareBuilder::class, loc)
        checkArgsSize(fn = "riseFlank", args = args, expected = 1, location = loc)
        val riseFlank = convertArgToKotlin(fn = "riseFlank", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptRiseFlank(riseFlank = riseFlank))
    }
}

internal fun KlangScriptExtensionBuilder.registerStdlibIgnitorBuildersChunk1() {

    // @TypeExtensions(OscSquareBuilder::class) on OscSquareBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSquareBuilder::class,
        name = "fallFlank",
        paramSpecs = listOf(
            ParamSpec(name = "fallFlank", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSquareBuilder::class, loc)
        checkArgsSize(fn = "fallFlank", args = args, expected = 1, location = loc)
        val fallFlank = convertArgToKotlin(fn = "fallFlank", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptFallFlank(fallFlank = fallFlank))
    }

    // @TypeExtensions(OscSawBuilder::class) on OscSawBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSawBuilder::class,
        name = "phase",
        paramSpecs = listOf(
            ParamSpec(name = "phase", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSawBuilder::class, loc)
        checkArgsSize(fn = "phase", args = args, expected = 1, location = loc)
        val phase = convertArgToKotlin(fn = "phase", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPhase(phase = phase))
    }

    // @TypeExtensions(OscSawBuilder::class) on OscSawBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSawBuilder::class,
        name = "analog",
        paramSpecs = listOf(
            ParamSpec(name = "character", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSawBuilder::class, loc)
        checkArgsSize(fn = "analog", args = args, expected = 1, location = loc)
        val character = convertArgToKotlin(fn = "analog", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalog(character = character))
    }

    // @TypeExtensions(OscSawBuilder::class) on OscSawBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSawBuilder::class,
        name = "resetSamples",
        paramSpecs = listOf(
            ParamSpec(name = "resetSamples", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSawBuilder::class, loc)
        checkArgsSize(fn = "resetSamples", args = args, expected = 1, location = loc)
        val resetSamples = convertArgToKotlin(fn = "resetSamples", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptResetSamples(resetSamples = resetSamples))
    }

    // @TypeExtensions(OscSawBuilder::class) on OscSawBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSawBuilder::class,
        name = "shapeMax",
        paramSpecs = listOf(
            ParamSpec(name = "shapeMax", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSawBuilder::class, loc)
        checkArgsSize(fn = "shapeMax", args = args, expected = 1, location = loc)
        val shapeMax = convertArgToKotlin(fn = "shapeMax", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptShapeMax(shapeMax = shapeMax))
    }

    // @TypeExtensions(OscRampBuilder::class) on OscRampBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscRampBuilder::class,
        name = "phase",
        paramSpecs = listOf(
            ParamSpec(name = "phase", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscRampBuilder::class, loc)
        checkArgsSize(fn = "phase", args = args, expected = 1, location = loc)
        val phase = convertArgToKotlin(fn = "phase", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPhase(phase = phase))
    }

    // @TypeExtensions(OscRampBuilder::class) on OscRampBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscRampBuilder::class,
        name = "analog",
        paramSpecs = listOf(
            ParamSpec(name = "character", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscRampBuilder::class, loc)
        checkArgsSize(fn = "analog", args = args, expected = 1, location = loc)
        val character = convertArgToKotlin(fn = "analog", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalog(character = character))
    }

    // @TypeExtensions(OscRampBuilder::class) on OscRampBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscRampBuilder::class,
        name = "resetSamples",
        paramSpecs = listOf(
            ParamSpec(name = "resetSamples", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscRampBuilder::class, loc)
        checkArgsSize(fn = "resetSamples", args = args, expected = 1, location = loc)
        val resetSamples = convertArgToKotlin(fn = "resetSamples", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptResetSamples(resetSamples = resetSamples))
    }

    // @TypeExtensions(OscRampBuilder::class) on OscRampBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscRampBuilder::class,
        name = "shapeMax",
        paramSpecs = listOf(
            ParamSpec(name = "shapeMax", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscRampBuilder::class, loc)
        checkArgsSize(fn = "shapeMax", args = args, expected = 1, location = loc)
        val shapeMax = convertArgToKotlin(fn = "shapeMax", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptShapeMax(shapeMax = shapeMax))
    }

    // @TypeExtensions(OscSuperSawBuilder::class) on OscSuperSawBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSawBuilder::class,
        name = "phase",
        paramSpecs = listOf(
            ParamSpec(name = "phase", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSawBuilder::class, loc)
        checkArgsSize(fn = "phase", args = args, expected = 1, location = loc)
        val phase = convertArgToKotlin(fn = "phase", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPhase(phase = phase))
    }

    // @TypeExtensions(OscSuperSawBuilder::class) on OscSuperSawBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSawBuilder::class,
        name = "voices",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSawBuilder::class, loc)
        checkArgsSize(fn = "voices", args = args, expected = 1, location = loc)
        val voices = convertArgToKotlin(fn = "voices", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptVoices(voices = voices))
    }

    // @TypeExtensions(OscSuperSawBuilder::class) on OscSuperSawBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSawBuilder::class,
        name = "spread",
        paramSpecs = listOf(
            ParamSpec(name = "spread", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSawBuilder::class, loc)
        checkArgsSize(fn = "spread", args = args, expected = 1, location = loc)
        val spread = convertArgToKotlin(fn = "spread", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptSpread(spread = spread))
    }

    // @TypeExtensions(OscSuperSawBuilder::class) on OscSuperSawBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSawBuilder::class,
        name = "analog",
        paramSpecs = listOf(
            ParamSpec(name = "character", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSawBuilder::class, loc)
        checkArgsSize(fn = "analog", args = args, expected = 1, location = loc)
        val character = convertArgToKotlin(fn = "analog", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalog(character = character))
    }

    // @TypeExtensions(OscSuperSawBuilder::class) on OscSuperSawBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSawBuilder::class,
        name = "analogSpread",
        paramSpecs = listOf(
            ParamSpec(name = "amount", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSawBuilder::class, loc)
        checkArgsSize(fn = "analogSpread", args = args, expected = 1, location = loc)
        val amount = convertArgToKotlin(fn = "analogSpread", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalogSpread(amount = amount))
    }

    // @TypeExtensions(OscSuperSawBuilder::class) on OscSuperSawBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSawBuilder::class,
        name = "spreadPower",
        paramSpecs = listOf(
            ParamSpec(name = "spreadPower", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSawBuilder::class, loc)
        checkArgsSize(fn = "spreadPower", args = args, expected = 1, location = loc)
        val spreadPower = convertArgToKotlin(fn = "spreadPower", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptSpreadPower(spreadPower = spreadPower))
    }

    // @TypeExtensions(OscSuperSawBuilder::class) on OscSuperSawBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSawBuilder::class,
        name = "sideAtten",
        paramSpecs = listOf(
            ParamSpec(name = "sideAtten", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSawBuilder::class, loc)
        checkArgsSize(fn = "sideAtten", args = args, expected = 1, location = loc)
        val sideAtten = convertArgToKotlin(fn = "sideAtten", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptSideAtten(sideAtten = sideAtten))
    }

    // @TypeExtensions(OscSuperSawBuilder::class) on OscSuperSawBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSawBuilder::class,
        name = "gainJitter",
        paramSpecs = listOf(
            ParamSpec(name = "gainJitter", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSawBuilder::class, loc)
        checkArgsSize(fn = "gainJitter", args = args, expected = 1, location = loc)
        val gainJitter = convertArgToKotlin(fn = "gainJitter", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptGainJitter(gainJitter = gainJitter))
    }

    // @TypeExtensions(OscSuperSawBuilder::class) on OscSuperSawBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSawBuilder::class,
        name = "centerJitter",
        paramSpecs = listOf(
            ParamSpec(name = "centerJitter", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSawBuilder::class, loc)
        checkArgsSize(fn = "centerJitter", args = args, expected = 1, location = loc)
        val centerJitter = convertArgToKotlin(fn = "centerJitter", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptCenterJitter(centerJitter = centerJitter))
    }

    // @TypeExtensions(OscSuperSawBuilder::class) on OscSuperSawBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSawBuilder::class,
        name = "phasePool",
        paramSpecs = listOf(
            ParamSpec(name = "on", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) }),
            ParamSpec(name = "kMin", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(0.30) }),
            ParamSpec(name = "kMax", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(0.55) }),
            ParamSpec(name = "drawTries", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(5.0) }),
            ParamSpec(name = "poolSize", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(256.0) }),
            ParamSpec(name = "refreshEvery", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(10.0) }),
            ParamSpec(name = "selection", kotlinType = String::class, isOptional = true, default = { wrapAsRuntimeValue("normal") }),
            ParamSpec(name = "warmup", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(16.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSawBuilder::class, loc)
        checkArgsSize(fn = "phasePool", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.scriptPhasePool(
                on = if (args.size > 0) convertArgToKotlin(fn = "phasePool", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double else 1.0,
                kMin = if (args.size > 1) convertArgToKotlin(fn = "phasePool", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double else 0.30,
                kMax = if (args.size > 2) convertArgToKotlin(fn = "phasePool", args = args, index = 2, cls = Double::class, nullable = false, loc = loc) as Double else 0.55,
                drawTries = if (args.size > 3) convertArgToKotlin(fn = "phasePool", args = args, index = 3, cls = Double::class, nullable = false, loc = loc) as Double else 5.0,
                poolSize = if (args.size > 4) convertArgToKotlin(fn = "phasePool", args = args, index = 4, cls = Double::class, nullable = false, loc = loc) as Double else 256.0,
                refreshEvery = if (args.size > 5) convertArgToKotlin(fn = "phasePool", args = args, index = 5, cls = Double::class, nullable = false, loc = loc) as Double else 10.0,
                selection = if (args.size > 6) convertArgToKotlin(fn = "phasePool", args = args, index = 6, cls = String::class, nullable = false, loc = loc) as String else "normal",
                warmup = if (args.size > 7) convertArgToKotlin(fn = "phasePool", args = args, index = 7, cls = Double::class, nullable = false, loc = loc) as Double else 16.0,
            )
        )
    }

    // @TypeExtensions(OscSuperSineBuilder::class) on OscSuperSineBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSineBuilder::class,
        name = "phase",
        paramSpecs = listOf(
            ParamSpec(name = "phase", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSineBuilder::class, loc)
        checkArgsSize(fn = "phase", args = args, expected = 1, location = loc)
        val phase = convertArgToKotlin(fn = "phase", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPhase(phase = phase))
    }

    // @TypeExtensions(OscSuperSineBuilder::class) on OscSuperSineBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSineBuilder::class,
        name = "voices",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSineBuilder::class, loc)
        checkArgsSize(fn = "voices", args = args, expected = 1, location = loc)
        val voices = convertArgToKotlin(fn = "voices", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptVoices(voices = voices))
    }

    // @TypeExtensions(OscSuperSineBuilder::class) on OscSuperSineBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSineBuilder::class,
        name = "spread",
        paramSpecs = listOf(
            ParamSpec(name = "spread", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSineBuilder::class, loc)
        checkArgsSize(fn = "spread", args = args, expected = 1, location = loc)
        val spread = convertArgToKotlin(fn = "spread", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptSpread(spread = spread))
    }

    // @TypeExtensions(OscSuperSineBuilder::class) on OscSuperSineBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSineBuilder::class,
        name = "analog",
        paramSpecs = listOf(
            ParamSpec(name = "character", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSineBuilder::class, loc)
        checkArgsSize(fn = "analog", args = args, expected = 1, location = loc)
        val character = convertArgToKotlin(fn = "analog", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalog(character = character))
    }
}

internal fun KlangScriptExtensionBuilder.registerStdlibIgnitorBuildersChunk2() {

    // @TypeExtensions(OscSuperSineBuilder::class) on OscSuperSineBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSineBuilder::class,
        name = "analogSpread",
        paramSpecs = listOf(
            ParamSpec(name = "amount", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSineBuilder::class, loc)
        checkArgsSize(fn = "analogSpread", args = args, expected = 1, location = loc)
        val amount = convertArgToKotlin(fn = "analogSpread", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalogSpread(amount = amount))
    }

    // @TypeExtensions(OscSuperSineBuilder::class) on OscSuperSineBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSineBuilder::class,
        name = "spreadPower",
        paramSpecs = listOf(
            ParamSpec(name = "spreadPower", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSineBuilder::class, loc)
        checkArgsSize(fn = "spreadPower", args = args, expected = 1, location = loc)
        val spreadPower = convertArgToKotlin(fn = "spreadPower", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptSpreadPower(spreadPower = spreadPower))
    }

    // @TypeExtensions(OscSuperSineBuilder::class) on OscSuperSineBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSineBuilder::class,
        name = "sideAtten",
        paramSpecs = listOf(
            ParamSpec(name = "sideAtten", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSineBuilder::class, loc)
        checkArgsSize(fn = "sideAtten", args = args, expected = 1, location = loc)
        val sideAtten = convertArgToKotlin(fn = "sideAtten", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptSideAtten(sideAtten = sideAtten))
    }

    // @TypeExtensions(OscSuperSineBuilder::class) on OscSuperSineBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSineBuilder::class,
        name = "gainJitter",
        paramSpecs = listOf(
            ParamSpec(name = "gainJitter", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSineBuilder::class, loc)
        checkArgsSize(fn = "gainJitter", args = args, expected = 1, location = loc)
        val gainJitter = convertArgToKotlin(fn = "gainJitter", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptGainJitter(gainJitter = gainJitter))
    }

    // @TypeExtensions(OscSuperSineBuilder::class) on OscSuperSineBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSineBuilder::class,
        name = "centerJitter",
        paramSpecs = listOf(
            ParamSpec(name = "centerJitter", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSineBuilder::class, loc)
        checkArgsSize(fn = "centerJitter", args = args, expected = 1, location = loc)
        val centerJitter = convertArgToKotlin(fn = "centerJitter", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptCenterJitter(centerJitter = centerJitter))
    }

    // @TypeExtensions(OscSuperSineBuilder::class) on OscSuperSineBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSineBuilder::class,
        name = "phasePool",
        paramSpecs = listOf(
            ParamSpec(name = "on", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) }),
            ParamSpec(name = "kMin", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(0.50) }),
            ParamSpec(name = "kMax", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(0.80) }),
            ParamSpec(name = "drawTries", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(40.0) }),
            ParamSpec(name = "poolSize", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(256.0) }),
            ParamSpec(name = "refreshEvery", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(10.0) }),
            ParamSpec(name = "selection", kotlinType = String::class, isOptional = true, default = { wrapAsRuntimeValue("normal") }),
            ParamSpec(name = "warmup", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(16.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSineBuilder::class, loc)
        checkArgsSize(fn = "phasePool", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.scriptPhasePool(
                on = if (args.size > 0) convertArgToKotlin(fn = "phasePool", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double else 1.0,
                kMin = if (args.size > 1) convertArgToKotlin(fn = "phasePool", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double else 0.50,
                kMax = if (args.size > 2) convertArgToKotlin(fn = "phasePool", args = args, index = 2, cls = Double::class, nullable = false, loc = loc) as Double else 0.80,
                drawTries = if (args.size > 3) convertArgToKotlin(fn = "phasePool", args = args, index = 3, cls = Double::class, nullable = false, loc = loc) as Double else 40.0,
                poolSize = if (args.size > 4) convertArgToKotlin(fn = "phasePool", args = args, index = 4, cls = Double::class, nullable = false, loc = loc) as Double else 256.0,
                refreshEvery = if (args.size > 5) convertArgToKotlin(fn = "phasePool", args = args, index = 5, cls = Double::class, nullable = false, loc = loc) as Double else 10.0,
                selection = if (args.size > 6) convertArgToKotlin(fn = "phasePool", args = args, index = 6, cls = String::class, nullable = false, loc = loc) as String else "normal",
                warmup = if (args.size > 7) convertArgToKotlin(fn = "phasePool", args = args, index = 7, cls = Double::class, nullable = false, loc = loc) as Double else 16.0,
            )
        )
    }

    // @TypeExtensions(OscSuperSquareBuilder::class) on OscSuperSquareBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSquareBuilder::class,
        name = "phase",
        paramSpecs = listOf(
            ParamSpec(name = "phase", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSquareBuilder::class, loc)
        checkArgsSize(fn = "phase", args = args, expected = 1, location = loc)
        val phase = convertArgToKotlin(fn = "phase", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPhase(phase = phase))
    }

    // @TypeExtensions(OscSuperSquareBuilder::class) on OscSuperSquareBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSquareBuilder::class,
        name = "voices",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSquareBuilder::class, loc)
        checkArgsSize(fn = "voices", args = args, expected = 1, location = loc)
        val voices = convertArgToKotlin(fn = "voices", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptVoices(voices = voices))
    }

    // @TypeExtensions(OscSuperSquareBuilder::class) on OscSuperSquareBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSquareBuilder::class,
        name = "spread",
        paramSpecs = listOf(
            ParamSpec(name = "spread", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSquareBuilder::class, loc)
        checkArgsSize(fn = "spread", args = args, expected = 1, location = loc)
        val spread = convertArgToKotlin(fn = "spread", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptSpread(spread = spread))
    }

    // @TypeExtensions(OscSuperSquareBuilder::class) on OscSuperSquareBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSquareBuilder::class,
        name = "analog",
        paramSpecs = listOf(
            ParamSpec(name = "character", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSquareBuilder::class, loc)
        checkArgsSize(fn = "analog", args = args, expected = 1, location = loc)
        val character = convertArgToKotlin(fn = "analog", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalog(character = character))
    }

    // @TypeExtensions(OscSuperSquareBuilder::class) on OscSuperSquareBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSquareBuilder::class,
        name = "analogSpread",
        paramSpecs = listOf(
            ParamSpec(name = "amount", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSquareBuilder::class, loc)
        checkArgsSize(fn = "analogSpread", args = args, expected = 1, location = loc)
        val amount = convertArgToKotlin(fn = "analogSpread", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalogSpread(amount = amount))
    }

    // @TypeExtensions(OscSuperSquareBuilder::class) on OscSuperSquareBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSquareBuilder::class,
        name = "spreadPower",
        paramSpecs = listOf(
            ParamSpec(name = "spreadPower", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSquareBuilder::class, loc)
        checkArgsSize(fn = "spreadPower", args = args, expected = 1, location = loc)
        val spreadPower = convertArgToKotlin(fn = "spreadPower", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptSpreadPower(spreadPower = spreadPower))
    }

    // @TypeExtensions(OscSuperSquareBuilder::class) on OscSuperSquareBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSquareBuilder::class,
        name = "sideAtten",
        paramSpecs = listOf(
            ParamSpec(name = "sideAtten", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSquareBuilder::class, loc)
        checkArgsSize(fn = "sideAtten", args = args, expected = 1, location = loc)
        val sideAtten = convertArgToKotlin(fn = "sideAtten", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptSideAtten(sideAtten = sideAtten))
    }

    // @TypeExtensions(OscSuperSquareBuilder::class) on OscSuperSquareBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSquareBuilder::class,
        name = "gainJitter",
        paramSpecs = listOf(
            ParamSpec(name = "gainJitter", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSquareBuilder::class, loc)
        checkArgsSize(fn = "gainJitter", args = args, expected = 1, location = loc)
        val gainJitter = convertArgToKotlin(fn = "gainJitter", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptGainJitter(gainJitter = gainJitter))
    }

    // @TypeExtensions(OscSuperSquareBuilder::class) on OscSuperSquareBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSquareBuilder::class,
        name = "centerJitter",
        paramSpecs = listOf(
            ParamSpec(name = "centerJitter", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSquareBuilder::class, loc)
        checkArgsSize(fn = "centerJitter", args = args, expected = 1, location = loc)
        val centerJitter = convertArgToKotlin(fn = "centerJitter", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptCenterJitter(centerJitter = centerJitter))
    }

    // @TypeExtensions(OscSuperSquareBuilder::class) on OscSuperSquareBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperSquareBuilder::class,
        name = "phasePool",
        paramSpecs = listOf(
            ParamSpec(name = "on", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) }),
            ParamSpec(name = "kMin", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(0.30) }),
            ParamSpec(name = "kMax", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(0.55) }),
            ParamSpec(name = "drawTries", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(5.0) }),
            ParamSpec(name = "poolSize", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(256.0) }),
            ParamSpec(name = "refreshEvery", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(10.0) }),
            ParamSpec(name = "selection", kotlinType = String::class, isOptional = true, default = { wrapAsRuntimeValue("normal") }),
            ParamSpec(name = "warmup", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(16.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperSquareBuilder::class, loc)
        checkArgsSize(fn = "phasePool", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.scriptPhasePool(
                on = if (args.size > 0) convertArgToKotlin(fn = "phasePool", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double else 1.0,
                kMin = if (args.size > 1) convertArgToKotlin(fn = "phasePool", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double else 0.30,
                kMax = if (args.size > 2) convertArgToKotlin(fn = "phasePool", args = args, index = 2, cls = Double::class, nullable = false, loc = loc) as Double else 0.55,
                drawTries = if (args.size > 3) convertArgToKotlin(fn = "phasePool", args = args, index = 3, cls = Double::class, nullable = false, loc = loc) as Double else 5.0,
                poolSize = if (args.size > 4) convertArgToKotlin(fn = "phasePool", args = args, index = 4, cls = Double::class, nullable = false, loc = loc) as Double else 256.0,
                refreshEvery = if (args.size > 5) convertArgToKotlin(fn = "phasePool", args = args, index = 5, cls = Double::class, nullable = false, loc = loc) as Double else 10.0,
                selection = if (args.size > 6) convertArgToKotlin(fn = "phasePool", args = args, index = 6, cls = String::class, nullable = false, loc = loc) as String else "normal",
                warmup = if (args.size > 7) convertArgToKotlin(fn = "phasePool", args = args, index = 7, cls = Double::class, nullable = false, loc = loc) as Double else 16.0,
            )
        )
    }

    // @TypeExtensions(OscSuperTriBuilder::class) on OscSuperTriBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperTriBuilder::class,
        name = "phase",
        paramSpecs = listOf(
            ParamSpec(name = "phase", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperTriBuilder::class, loc)
        checkArgsSize(fn = "phase", args = args, expected = 1, location = loc)
        val phase = convertArgToKotlin(fn = "phase", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPhase(phase = phase))
    }

    // @TypeExtensions(OscSuperTriBuilder::class) on OscSuperTriBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperTriBuilder::class,
        name = "voices",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperTriBuilder::class, loc)
        checkArgsSize(fn = "voices", args = args, expected = 1, location = loc)
        val voices = convertArgToKotlin(fn = "voices", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptVoices(voices = voices))
    }

    // @TypeExtensions(OscSuperTriBuilder::class) on OscSuperTriBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperTriBuilder::class,
        name = "spread",
        paramSpecs = listOf(
            ParamSpec(name = "spread", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperTriBuilder::class, loc)
        checkArgsSize(fn = "spread", args = args, expected = 1, location = loc)
        val spread = convertArgToKotlin(fn = "spread", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptSpread(spread = spread))
    }
}

internal fun KlangScriptExtensionBuilder.registerStdlibIgnitorBuildersChunk3() {

    // @TypeExtensions(OscSuperTriBuilder::class) on OscSuperTriBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperTriBuilder::class,
        name = "analog",
        paramSpecs = listOf(
            ParamSpec(name = "character", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperTriBuilder::class, loc)
        checkArgsSize(fn = "analog", args = args, expected = 1, location = loc)
        val character = convertArgToKotlin(fn = "analog", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalog(character = character))
    }

    // @TypeExtensions(OscSuperTriBuilder::class) on OscSuperTriBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperTriBuilder::class,
        name = "analogSpread",
        paramSpecs = listOf(
            ParamSpec(name = "amount", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperTriBuilder::class, loc)
        checkArgsSize(fn = "analogSpread", args = args, expected = 1, location = loc)
        val amount = convertArgToKotlin(fn = "analogSpread", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalogSpread(amount = amount))
    }

    // @TypeExtensions(OscSuperTriBuilder::class) on OscSuperTriBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperTriBuilder::class,
        name = "spreadPower",
        paramSpecs = listOf(
            ParamSpec(name = "spreadPower", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperTriBuilder::class, loc)
        checkArgsSize(fn = "spreadPower", args = args, expected = 1, location = loc)
        val spreadPower = convertArgToKotlin(fn = "spreadPower", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptSpreadPower(spreadPower = spreadPower))
    }

    // @TypeExtensions(OscSuperTriBuilder::class) on OscSuperTriBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperTriBuilder::class,
        name = "sideAtten",
        paramSpecs = listOf(
            ParamSpec(name = "sideAtten", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperTriBuilder::class, loc)
        checkArgsSize(fn = "sideAtten", args = args, expected = 1, location = loc)
        val sideAtten = convertArgToKotlin(fn = "sideAtten", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptSideAtten(sideAtten = sideAtten))
    }

    // @TypeExtensions(OscSuperTriBuilder::class) on OscSuperTriBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperTriBuilder::class,
        name = "gainJitter",
        paramSpecs = listOf(
            ParamSpec(name = "gainJitter", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperTriBuilder::class, loc)
        checkArgsSize(fn = "gainJitter", args = args, expected = 1, location = loc)
        val gainJitter = convertArgToKotlin(fn = "gainJitter", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptGainJitter(gainJitter = gainJitter))
    }

    // @TypeExtensions(OscSuperTriBuilder::class) on OscSuperTriBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperTriBuilder::class,
        name = "centerJitter",
        paramSpecs = listOf(
            ParamSpec(name = "centerJitter", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperTriBuilder::class, loc)
        checkArgsSize(fn = "centerJitter", args = args, expected = 1, location = loc)
        val centerJitter = convertArgToKotlin(fn = "centerJitter", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptCenterJitter(centerJitter = centerJitter))
    }

    // @TypeExtensions(OscSuperTriBuilder::class) on OscSuperTriBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperTriBuilder::class,
        name = "phasePool",
        paramSpecs = listOf(
            ParamSpec(name = "on", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) }),
            ParamSpec(name = "kMin", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(0.40) }),
            ParamSpec(name = "kMax", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(0.65) }),
            ParamSpec(name = "drawTries", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(16.0) }),
            ParamSpec(name = "poolSize", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(256.0) }),
            ParamSpec(name = "refreshEvery", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(10.0) }),
            ParamSpec(name = "selection", kotlinType = String::class, isOptional = true, default = { wrapAsRuntimeValue("normal") }),
            ParamSpec(name = "warmup", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(16.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperTriBuilder::class, loc)
        checkArgsSize(fn = "phasePool", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.scriptPhasePool(
                on = if (args.size > 0) convertArgToKotlin(fn = "phasePool", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double else 1.0,
                kMin = if (args.size > 1) convertArgToKotlin(fn = "phasePool", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double else 0.40,
                kMax = if (args.size > 2) convertArgToKotlin(fn = "phasePool", args = args, index = 2, cls = Double::class, nullable = false, loc = loc) as Double else 0.65,
                drawTries = if (args.size > 3) convertArgToKotlin(fn = "phasePool", args = args, index = 3, cls = Double::class, nullable = false, loc = loc) as Double else 16.0,
                poolSize = if (args.size > 4) convertArgToKotlin(fn = "phasePool", args = args, index = 4, cls = Double::class, nullable = false, loc = loc) as Double else 256.0,
                refreshEvery = if (args.size > 5) convertArgToKotlin(fn = "phasePool", args = args, index = 5, cls = Double::class, nullable = false, loc = loc) as Double else 10.0,
                selection = if (args.size > 6) convertArgToKotlin(fn = "phasePool", args = args, index = 6, cls = String::class, nullable = false, loc = loc) as String else "normal",
                warmup = if (args.size > 7) convertArgToKotlin(fn = "phasePool", args = args, index = 7, cls = Double::class, nullable = false, loc = loc) as Double else 16.0,
            )
        )
    }

    // @TypeExtensions(OscSuperRampBuilder::class) on OscSuperRampBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperRampBuilder::class,
        name = "phase",
        paramSpecs = listOf(
            ParamSpec(name = "phase", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperRampBuilder::class, loc)
        checkArgsSize(fn = "phase", args = args, expected = 1, location = loc)
        val phase = convertArgToKotlin(fn = "phase", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPhase(phase = phase))
    }

    // @TypeExtensions(OscSuperRampBuilder::class) on OscSuperRampBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperRampBuilder::class,
        name = "voices",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperRampBuilder::class, loc)
        checkArgsSize(fn = "voices", args = args, expected = 1, location = loc)
        val voices = convertArgToKotlin(fn = "voices", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptVoices(voices = voices))
    }

    // @TypeExtensions(OscSuperRampBuilder::class) on OscSuperRampBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperRampBuilder::class,
        name = "spread",
        paramSpecs = listOf(
            ParamSpec(name = "spread", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperRampBuilder::class, loc)
        checkArgsSize(fn = "spread", args = args, expected = 1, location = loc)
        val spread = convertArgToKotlin(fn = "spread", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptSpread(spread = spread))
    }

    // @TypeExtensions(OscSuperRampBuilder::class) on OscSuperRampBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperRampBuilder::class,
        name = "analog",
        paramSpecs = listOf(
            ParamSpec(name = "character", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperRampBuilder::class, loc)
        checkArgsSize(fn = "analog", args = args, expected = 1, location = loc)
        val character = convertArgToKotlin(fn = "analog", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalog(character = character))
    }

    // @TypeExtensions(OscSuperRampBuilder::class) on OscSuperRampBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperRampBuilder::class,
        name = "analogSpread",
        paramSpecs = listOf(
            ParamSpec(name = "amount", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperRampBuilder::class, loc)
        checkArgsSize(fn = "analogSpread", args = args, expected = 1, location = loc)
        val amount = convertArgToKotlin(fn = "analogSpread", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalogSpread(amount = amount))
    }

    // @TypeExtensions(OscSuperRampBuilder::class) on OscSuperRampBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperRampBuilder::class,
        name = "spreadPower",
        paramSpecs = listOf(
            ParamSpec(name = "spreadPower", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperRampBuilder::class, loc)
        checkArgsSize(fn = "spreadPower", args = args, expected = 1, location = loc)
        val spreadPower = convertArgToKotlin(fn = "spreadPower", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptSpreadPower(spreadPower = spreadPower))
    }

    // @TypeExtensions(OscSuperRampBuilder::class) on OscSuperRampBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperRampBuilder::class,
        name = "sideAtten",
        paramSpecs = listOf(
            ParamSpec(name = "sideAtten", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperRampBuilder::class, loc)
        checkArgsSize(fn = "sideAtten", args = args, expected = 1, location = loc)
        val sideAtten = convertArgToKotlin(fn = "sideAtten", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptSideAtten(sideAtten = sideAtten))
    }

    // @TypeExtensions(OscSuperRampBuilder::class) on OscSuperRampBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperRampBuilder::class,
        name = "gainJitter",
        paramSpecs = listOf(
            ParamSpec(name = "gainJitter", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperRampBuilder::class, loc)
        checkArgsSize(fn = "gainJitter", args = args, expected = 1, location = loc)
        val gainJitter = convertArgToKotlin(fn = "gainJitter", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptGainJitter(gainJitter = gainJitter))
    }

    // @TypeExtensions(OscSuperRampBuilder::class) on OscSuperRampBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperRampBuilder::class,
        name = "centerJitter",
        paramSpecs = listOf(
            ParamSpec(name = "centerJitter", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperRampBuilder::class, loc)
        checkArgsSize(fn = "centerJitter", args = args, expected = 1, location = loc)
        val centerJitter = convertArgToKotlin(fn = "centerJitter", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.scriptCenterJitter(centerJitter = centerJitter))
    }

    // @TypeExtensions(OscSuperRampBuilder::class) on OscSuperRampBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperRampBuilder::class,
        name = "phasePool",
        paramSpecs = listOf(
            ParamSpec(name = "on", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) }),
            ParamSpec(name = "kMin", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(0.30) }),
            ParamSpec(name = "kMax", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(0.55) }),
            ParamSpec(name = "drawTries", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(5.0) }),
            ParamSpec(name = "poolSize", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(256.0) }),
            ParamSpec(name = "refreshEvery", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(10.0) }),
            ParamSpec(name = "selection", kotlinType = String::class, isOptional = true, default = { wrapAsRuntimeValue("normal") }),
            ParamSpec(name = "warmup", kotlinType = Double::class, isOptional = true, default = { wrapAsRuntimeValue(16.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperRampBuilder::class, loc)
        checkArgsSize(fn = "phasePool", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.scriptPhasePool(
                on = if (args.size > 0) convertArgToKotlin(fn = "phasePool", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double else 1.0,
                kMin = if (args.size > 1) convertArgToKotlin(fn = "phasePool", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double else 0.30,
                kMax = if (args.size > 2) convertArgToKotlin(fn = "phasePool", args = args, index = 2, cls = Double::class, nullable = false, loc = loc) as Double else 0.55,
                drawTries = if (args.size > 3) convertArgToKotlin(fn = "phasePool", args = args, index = 3, cls = Double::class, nullable = false, loc = loc) as Double else 5.0,
                poolSize = if (args.size > 4) convertArgToKotlin(fn = "phasePool", args = args, index = 4, cls = Double::class, nullable = false, loc = loc) as Double else 256.0,
                refreshEvery = if (args.size > 5) convertArgToKotlin(fn = "phasePool", args = args, index = 5, cls = Double::class, nullable = false, loc = loc) as Double else 10.0,
                selection = if (args.size > 6) convertArgToKotlin(fn = "phasePool", args = args, index = 6, cls = String::class, nullable = false, loc = loc) as String else "normal",
                warmup = if (args.size > 7) convertArgToKotlin(fn = "phasePool", args = args, index = 7, cls = Double::class, nullable = false, loc = loc) as Double else 16.0,
            )
        )
    }

    // @TypeExtensions(OscPluckBuilder::class) on OscPluckBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscPluckBuilder::class,
        name = "feedback",
        paramSpecs = listOf(
            ParamSpec(name = "feedback", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscPluckBuilder::class, loc)
        checkArgsSize(fn = "feedback", args = args, expected = 1, location = loc)
        val feedback = convertArgToKotlin(fn = "feedback", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptFeedback(feedback = feedback))
    }

    // @TypeExtensions(OscPluckBuilder::class) on OscPluckBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscPluckBuilder::class,
        name = "brightness",
        paramSpecs = listOf(
            ParamSpec(name = "brightness", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscPluckBuilder::class, loc)
        checkArgsSize(fn = "brightness", args = args, expected = 1, location = loc)
        val brightness = convertArgToKotlin(fn = "brightness", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptBrightness(brightness = brightness))
    }
}

internal fun KlangScriptExtensionBuilder.registerStdlibIgnitorBuildersChunk4() {

    // @TypeExtensions(OscPluckBuilder::class) on OscPluckBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscPluckBuilder::class,
        name = "pickPosition",
        paramSpecs = listOf(
            ParamSpec(name = "pickPosition", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscPluckBuilder::class, loc)
        checkArgsSize(fn = "pickPosition", args = args, expected = 1, location = loc)
        val pickPosition = convertArgToKotlin(fn = "pickPosition", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPickPosition(pickPosition = pickPosition))
    }

    // @TypeExtensions(OscPluckBuilder::class) on OscPluckBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscPluckBuilder::class,
        name = "stiffness",
        paramSpecs = listOf(
            ParamSpec(name = "stiffness", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscPluckBuilder::class, loc)
        checkArgsSize(fn = "stiffness", args = args, expected = 1, location = loc)
        val stiffness = convertArgToKotlin(fn = "stiffness", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptStiffness(stiffness = stiffness))
    }

    // @TypeExtensions(OscPluckBuilder::class) on OscPluckBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscPluckBuilder::class,
        name = "analog",
        paramSpecs = listOf(
            ParamSpec(name = "character", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscPluckBuilder::class, loc)
        checkArgsSize(fn = "analog", args = args, expected = 1, location = loc)
        val character = convertArgToKotlin(fn = "analog", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalog(character = character))
    }

    // @TypeExtensions(OscSuperPluckBuilder::class) on OscSuperPluckBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperPluckBuilder::class,
        name = "voices",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperPluckBuilder::class, loc)
        checkArgsSize(fn = "voices", args = args, expected = 1, location = loc)
        val voices = convertArgToKotlin(fn = "voices", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptVoices(voices = voices))
    }

    // @TypeExtensions(OscSuperPluckBuilder::class) on OscSuperPluckBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperPluckBuilder::class,
        name = "spread",
        paramSpecs = listOf(
            ParamSpec(name = "spread", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperPluckBuilder::class, loc)
        checkArgsSize(fn = "spread", args = args, expected = 1, location = loc)
        val spread = convertArgToKotlin(fn = "spread", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptSpread(spread = spread))
    }

    // @TypeExtensions(OscSuperPluckBuilder::class) on OscSuperPluckBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperPluckBuilder::class,
        name = "feedback",
        paramSpecs = listOf(
            ParamSpec(name = "feedback", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperPluckBuilder::class, loc)
        checkArgsSize(fn = "feedback", args = args, expected = 1, location = loc)
        val feedback = convertArgToKotlin(fn = "feedback", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptFeedback(feedback = feedback))
    }

    // @TypeExtensions(OscSuperPluckBuilder::class) on OscSuperPluckBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperPluckBuilder::class,
        name = "brightness",
        paramSpecs = listOf(
            ParamSpec(name = "brightness", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperPluckBuilder::class, loc)
        checkArgsSize(fn = "brightness", args = args, expected = 1, location = loc)
        val brightness = convertArgToKotlin(fn = "brightness", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptBrightness(brightness = brightness))
    }

    // @TypeExtensions(OscSuperPluckBuilder::class) on OscSuperPluckBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperPluckBuilder::class,
        name = "pickPosition",
        paramSpecs = listOf(
            ParamSpec(name = "pickPosition", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperPluckBuilder::class, loc)
        checkArgsSize(fn = "pickPosition", args = args, expected = 1, location = loc)
        val pickPosition = convertArgToKotlin(fn = "pickPosition", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPickPosition(pickPosition = pickPosition))
    }

    // @TypeExtensions(OscSuperPluckBuilder::class) on OscSuperPluckBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperPluckBuilder::class,
        name = "stiffness",
        paramSpecs = listOf(
            ParamSpec(name = "stiffness", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperPluckBuilder::class, loc)
        checkArgsSize(fn = "stiffness", args = args, expected = 1, location = loc)
        val stiffness = convertArgToKotlin(fn = "stiffness", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptStiffness(stiffness = stiffness))
    }

    // @TypeExtensions(OscSuperPluckBuilder::class) on OscSuperPluckBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperPluckBuilder::class,
        name = "analog",
        paramSpecs = listOf(
            ParamSpec(name = "character", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperPluckBuilder::class, loc)
        checkArgsSize(fn = "analog", args = args, expected = 1, location = loc)
        val character = convertArgToKotlin(fn = "analog", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalog(character = character))
    }

    // @TypeExtensions(OscSuperPluckBuilder::class) on OscSuperPluckBuilder
    registerExtensionMethodWithSpecs(
        receiver = OscSuperPluckBuilder::class,
        name = "analogSpread",
        paramSpecs = listOf(
            ParamSpec(name = "amount", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(OscSuperPluckBuilder::class, loc)
        checkArgsSize(fn = "analogSpread", args = args, expected = 1, location = loc)
        val amount = convertArgToKotlin(fn = "analogSpread", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAnalogSpread(amount = amount))
    }
}

